import axios from "axios";
import config from "./env";

const request = ({ url, method, data, params, headers, responseType }) => {

    const token = localStorage.getItem('accessToken');

    const { apiUrl } = config
    
    return new Promise((resolve, reject) => {


        const config = {
            url: apiUrl + url,
            method: method,
            data: data || null,
            params: params || null,
            responseType : responseType,
            headers: {
                'Authorization': token ? `Bearer ${token}` : '',
                'Content-Type': "application/json",
                Accept: "application/json",
                ...headers
            }
        };

        axios(config)
            .then((res) => resolve(res))
            .catch((err) => {
                const { response } = err;
                if (response && response.status === 403) {
                    window.location.href = "/auth/login";
                }
                reject(err);
            });
    });
}

export default request;